import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const t = (lang, ja, en) => (lang === 'en' ? en : ja);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('struct-code-lang') || 'ja';
  });

  useEffect(() => {
    localStorage.setItem('struct-code-lang', lang);
  }, [lang]);

  const toggleLanguage = () => {
    setLang(prev => prev === 'ja' ? 'en' : 'ja');
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLanguage, t: (ja, en) => t(lang, ja, en) }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
